// extracted by mini-css-extract-plugin
export default {"load-more-button":"load-more-button--wPwuo","hidden":"hidden--17fpU"};